import useAsyncData from "../../../../hooks/use-async-data";
import ContractsCargoTaxiDetails from "./contracts-cargo-taxi-details";
import ContractsCargoTaxiDetailsParams from "./contracts-cargo-taxi-details-params";
import contractsService from "../../contracts.service";

const useContractsCargoTaxiDetails = () => {
  const { isLoading, setIsLoading, isError, setIsError, data, setData } =
    useAsyncData<ContractsCargoTaxiDetails | null>(null);

  const load = async (
    params: ContractsCargoTaxiDetailsParams,
    signal: AbortSignal,
  ): Promise<void> => {
    setIsLoading(true);
    setIsError(false);

    try {
      const cargoTaxiContractDetails =
        await contractsService.getCargoTaxiContractDetails(params, signal);

      setData(cargoTaxiContractDetails);
    } catch (_error) {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    isError,
    data,
    load,
  };
};

export default useContractsCargoTaxiDetails;
